// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#autocomplete-wrapper,
#autocomplete-input {
  width: 98%;
  position: relative;
  display: flex;
  flex-direction: column;
}
#autocomplete-wrapper .close,
#autocomplete-input .close {
  position: absolute;
  right: 30px;
  font-size: 14px;
  width: 32px !important;
  height: 32px;
  top: 4px;
  cursor: pointer;
}

.tags-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 5px;
  width: 100%;
  align-items: center;
  padding: 5px 0;
}

.tag {
  display: inline-flex;
  align-items: center;
  padding: 4px 8px 4px 12px;
  background-color: #C8E6C9;
  color: #424242;
  border-radius: 16px;
  font-size: 14px;
  line-height: 1.4;
  white-space: pre-wrap;
  max-width: 100%;
  height: 100%;
}

.tag-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  margin-left: 6px;
  background-color: #424242;
  color: white;
  border-radius: 50%;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  line-height: 1;
  flex-shrink: 0;
  transition: background-color 0.2s;
}

.tag-close:hover {
  background-color: #212121;
}

.search {
  z-index: 1000;
  cursor: pointer;
  background-color: #fff;
  font-family: sans-serif;
  opacity: 0.98;
  border-radius: 5px;
}

mark {
  background-color: transparent !important;
  font-weight: bold !important;
}

.search-result {
  padding: 4px 10px;
  font-size: 15px;
}

.search-result:first-child {
  border-left: 2px solid #133AA5;
}

.search-result:hover {
  background-color: #eceffe;
}

input {
  width: 100%;
  height: 40px;
  color: #111 !important;
  border: none;
  border-top-left-radius: 10px;
  margin-left: 0px;
  border-top-right-radius: 10px;
  padding: 0px 15px;
}

textarea {
  width: 98% !important;
  margin: auto;
  border: none !important;
  resize: none !important;
  margin: 5px;
  height: 75px;
  overflow-y: auto;
  background: transparent;
  color: #4b4b4b;
  font-size: 1.1rem !important;
}

input::placeholder, textarea::placeholder {
  color: rgb(107, 107, 107) !important;
  text-transform: capitalize;
  font-size: 1.1rem !important;
}

#suggestion-list {
  width: inherit;
  font-size: 0.9rem !important;
  border-radius: 5px;
  box-shadow: rgba(0, 0, 0, 0.09) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 2px 2px, rgba(0, 0, 0, 0.09) 0px 2px 4px, rgba(0, 0, 0, 0.09) 0px 2px 8px, rgba(0, 0, 0, 0.09) 0px 2px 5px;
  max-height: 200px;
  overflow-y: auto;
  position: absolute;
  z-index: 99;
  top: 43px;
}
#suggestion-list p {
  padding: 10px;
}

::-webkit-scrollbar {
  width: 3px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #eee;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #eee;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #eee;
}

.editable-input {
  min-height: 88px;
  max-height: 200px;
  overflow-y: auto;
  width: 100%;
  padding: 10px;
  font-size: 14px;
  white-space: pre-wrap;
}`, "",{"version":3,"sources":["webpack://./src/app/components/ai-assist/autocomplete/autocomplete.component.scss"],"names":[],"mappings":"AAOA;;EAEE,UAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AANF;AASE;;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,QAAA;EACA,eAAA;AANJ;;AAWA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;AARF;;AAYA;EACE,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,YAAA;AATF;;AAaA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;EACA,iCAAA;AAVF;;AAcA;EACE,yBAAA;AAXF;;AAeA;EACE,aAAA;EACA,eAAA;EAGA,sBAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;AAdF;;AAoBA;EACE,wCAAA;EACA,4BAAA;AAjBF;;AAqBA;EACE,iBAAA;EACA,eAAA;AAlBF;;AAsBA;EACE,8BAAA;AAnBF;;AAuBA;EAGE,yBAAA;AAtBF;;AA4BA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,YAAA;EACA,4BAAA;EACA,gBAAA;EACA,6BAAA;EACA,iBAAA;AAzBF;;AA4BA;EACE,qBAAA;EACA,YAAA;EACA,uBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EAEA,cAAA;EACA,4BAAA;AA1BF;;AA4BA;EACE,oCAAA;EACA,0BAAA;EACA,4BAAA;AAzBF;;AA6BA;EACE,cAAA;EACA,4BAAA;EACA,kBAAA;EAEA,+KAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;AA3BF;AA8BE;EACE,aAAA;AA5BJ;;AAiCA;EACE,UAAA;AA9BF;;AAkCA,UAAA;AACA;EACE,gBAAA;AA/BF;;AAmCA,WAAA;AACA;EACE,gBAAA;AAhCF;;AAoCA,oBAAA;AACA;EACE,gBAAA;AAjCF;;AAqCA;EACE,gBAAA;EACA,iBAAA;EACA,gBAAA;EAEA,WAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;AAnCF","sourcesContent":[":host {\n  // width:100%;\n  // position: relative;\n  // display: flex;\n}\n\n\n#autocomplete-wrapper,\n#autocomplete-input {\n  width: 98%;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n\n\n  .close {\n    position: absolute;\n    right: 30px;\n    font-size: 14px;\n    width: 32px !important;\n    height: 32px;\n    top: 4px;\n    cursor: pointer;\n  }\n}\n\n\n.tags-wrapper {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 5px;\n  width: 100%;\n  align-items: center;\n  padding: 5px 0;\n}\n\n\n.tag {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 8px 4px 12px;\n  background-color: #C8E6C9;\n  color: #424242;\n  border-radius: 16px;\n  font-size: 14px;\n  line-height: 1.4;\n  white-space: pre-wrap;\n  max-width: 100%;\n  height: 100%;\n}\n\n\n.tag-close {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  margin-left: 6px;\n  background-color: #424242;\n  color: white;\n  border-radius: 50%;\n  font-size: 14px;\n  font-weight: bold;\n  cursor: pointer;\n  line-height: 1;\n  flex-shrink: 0;\n  transition: background-color 0.2s;\n}\n\n\n.tag-close:hover {\n  background-color: #212121;\n}\n\n\n.search {\n  z-index: 1000;\n  cursor: pointer;\n\n\n  background-color: #fff;\n  font-family: sans-serif;\n  opacity: 0.98;\n  border-radius: 5px;\n\n\n}\n\n\nmark {\n  background-color: transparent !important;\n  font-weight: bold !important;\n}\n\n\n.search-result {\n  padding: 4px 10px;\n  font-size: 15px;\n}\n\n\n.search-result:first-child {\n  border-left: 2px solid #133AA5;\n}\n\n\n.search-result:hover {\n\n\n  background-color: #eceffe;\n\n\n}\n\n\ninput {\n  width: 100%;\n  height: 40px;\n  color: #111 !important;\n  border: none;\n  border-top-left-radius: 10px;\n  margin-left: 0px;\n  border-top-right-radius: 10px;\n  padding: 0px 15px;\n  //font-family:\"Noto Sans\", sans-serif;\n}\ntextarea{\n  width:98% !important;\n  margin: auto;\n  border: none !important;\n  resize: none !important;\n  margin: 5px;\n  height: 75px;\n  overflow-y: auto;\n  background: transparent;\n  //color: var(--textsecondarycolor) !important;\n  color:#4b4b4b;\n  font-size:1.1rem !important;\n}\ninput::placeholder,textarea::placeholder {\n  color: rgb(107, 107, 107) !important;\n  text-transform: capitalize;\n  font-size:1.1rem !important;\n}\n\n\n#suggestion-list {\n  width: inherit;\n  font-size: .9rem !important;\n  border-radius: 5px;\n  //margin-top:-3px;\n  box-shadow: rgba(0, 0, 0, 0.09) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 2px 2px, rgba(0, 0, 0, 0.09) 0px 2px 4px, rgba(0, 0, 0, 0.09) 0px 2px 8px, rgba(0, 0, 0, 0.09) 0px 2px 5px;\n  max-height: 200px;\n  overflow-y: auto;\n  position: absolute;\n  z-index: 99;\n  top: 43px;\n\n\n  p {\n    padding: 10px;\n  }\n}\n\n\n::-webkit-scrollbar {\n  width: 3px;\n}\n\n\n/* Track */\n::-webkit-scrollbar-track {\n  background: #eee;\n}\n\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: #eee;\n}\n\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: #eee;\n}\n\n\n.editable-input {\n  min-height: 88px;\n  max-height: 200px;\n  overflow-y: auto;\n  // border: 1px solid #ccc;\n  width: 100%;\n  padding: 10px;\n  font-size: 14px;\n  white-space: pre-wrap;\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
